import React, { useEffect } from "react";
import ErrorBoundary from "../ErrorBoundary";
import { fetchHomeWidgetInfo } from "../../store/actions/ceHomeWidget";
import { useStore, useDispatch } from "../../store";
import {
  CallToAction,
  Type,
  Table,
  TableBody,
  Anchor,
} from "discover.medical.react-component-library";
import { StyledCell, StyledRow, StyledBox, StyledButton } from "./_.styled.js";

export const CEHomeWidgetDMP = () => {
  const dispatch = useDispatch();
  const { homeWidget } = useStore();

  useEffect(() => {
    fetchHomeWidgetInfo(dispatch);
  }, [dispatch]);

  if (!Object.keys(homeWidget).length) {
    return null;
  }

  const {
    header: { title: widgetTitle, userName, claimed },
    body: { text: creditsData },
    footer: {
      title: footerTitle,
      counter,
      button: { text: buttonText, route },
    },
  } = homeWidget;

  return (
    <ErrorBoundary team="cd.levant">
      <CallToAction avatar={false} padding="lg" data-testid="ce-widget">
        <Type
          element="p"
          fontFamily="secondary"
          fontSize="xxl"
          marginBottom="xs"
          data-testid="ce-widget-title"
        >
          {widgetTitle}
        </Type>
        <Type
          element="p"
          fontSize="md"
          marginBottom="sm"
          data-testid="ce-widget-user"
        >
          {userName}
        </Type>
        {claimed && (
          <Type
            element="p"
            fontSize="md"
            marginBottom="sm"
            data-testid="ce-widget-claimed-title"
          >
            {claimed}
          </Type>
        )}
        {!!creditsData.length && (
          <Table>
            <TableBody>
              {creditsData.map((row, index) => (
                <StyledRow key={index}>
                  <StyledCell>
                    <Type
                      element="p"
                      fontSize="md"
                      data-testid="ce-widget-claimed-label"
                    >
                      {row.label}
                    </Type>
                  </StyledCell>
                  <StyledCell align="right">
                    <Type
                      element="p"
                      fontSize="md"
                      fontWeight="bold"
                      data-testid="ce-widget-claimed-value"
                    >
                      {row.value}
                    </Type>
                  </StyledCell>
                </StyledRow>
              ))}
            </TableBody>
          </Table>
        )}
        <StyledBox>
          <Type
            element="p"
            fontSize="md"
            color="white"
            data-testid="ce-widget-available"
          >
            {footerTitle}
            <Type
              element="span"
              fontSize="md"
              fontWeight="bold"
              color="white"
              data-testid="ce-widget-claimed-counter"
            >
              {" "}
              {counter}
            </Type>
          </Type>
          {buttonText && (
            <Anchor
              as={StyledButton}
              href={route}
              data-testid="ce-widget-button"
            >
              {buttonText}
            </Anchor>
          )}
        </StyledBox>
      </CallToAction>
    </ErrorBoundary>
  );
};

export default CEHomeWidgetDMP;
